// 法语
export default {
  day: 'jour',
  hour: 'heure',
  min: 'minute',
  sesc: 'seconde',
  cancel: 'annuler',
  confirm: 'confirmer',
  showMore: 'voir plus',
  hideMore: 'cacher',
  per_sale: { 
    title: 'La phase de prévente se termine dans {days} jours {hours} heures {mins} minutes {secs} secondes',
    title1: 'Pour participer à la vente publique, il est nécessaire de compléter le KYC',
    text: 'Acheter DLC',
    text1: 'Participer au KYC',
  },
  meau: {
    nav1: "Qu'est-ce que DeepLink?",
    nav2: 'Comment acheter?',
    nav3: 'Livre blanc',
    nav4: 'PITCH DECK',
    nav5: 'FAQ',
    nav6: 'Research',
    add: 'Adresse:',
    link: 'Connecter le portefeuille',
  },
  home: {
    intro: {
      title: 'DeepLink Public Sale',
      text: 'Compte à rebours de la première phase de la vente publique:',
      text1: 'Le KYC actuel est déjà en cours',
      text2: 'Compte à rebours avant la fin de la Phase 5 de la Vente Publique',
      text3: 'Compte à rebours de la deuxième phase de la vente publique:',
      text4: 'La vente publique est terminée',
      tip: "Veuillez vous assurer de compléter la vérification KYC avant d\'acheter des jetons (DLC)",
      tip1: 'Ne pas acheter de manière répétée',
    },
    desc: {
      title: 'Deeplink se compose de deux parties : DeepLink Protocol et Deeplink Software',
      left: {
        text: 'Tous les paiements sont effectués avec des tokens DeepLink!',
        text1: 'DeepLink Protocol est un protocole de jeu en nuage IA décentralisé,',
        text2: 'qui combine la technologie de l\'IA et de la blockchain pour fournir une technologie de rendu de jeu à latence ultra-faible. DeepLink Software est un logiciel de contrôle à distance des jeux et une plateforme de jeux en nuage développée sur la base de DeepLink Protocol. D\'autres produits développés sur la base de DeepLink Protocol incluent une plateforme de cybercafé en nuage, une machine de jeu en nuage basée sur la blockchain, une console de jeu portable basée sur la blockchain, etc.',
        text3: '100% Secure & Verified',
        btn1: 'Introduction au DeepLink Protocol',
        btn2: 'Introduction au DeepLink Software',
      },
      right: {
        text1: 'Public Sale est en cours',
        text1_1: 'KYC est en cours',
        text1_2: 'Public Sale Phase {pre_num1} est en cours',
        // text2: 'Prix du DLC : 1DLC={price}USDT, reste {days} jours {hour} heures {min} minutes',
        text2: 'Prix du DLC : 1DLC={price}USDT',
        text3: 'La {pre_num}ème Public Sale est terminée',
        text4: 'La phase {pre_num1} est sur le point de commencer',
        text5: 'Public Sale est sur le point de commencer',
        text6: 'Veuillez compléter le processus de vérification KYC avant de participer à la vente publique. Merci pour votre coopération.',
        // text7: "Récompense supplémentaire de 10 % de tokens à l'étape actuelle, la récompense sera réduite à 5 % à l'étape suivante",
        text7: "Récompense supplémentaire de 5 % de tokens à l'étape actuelle, aucune récompense supplémentaire à l'étape suivante",
        text8: 'Rejoignez la communauté et participez au tirage au sort pour gagner 10 000 USDT et DLC',
        process: 'Terminé {process}%',
        btn1: 'Participer à la vérification KYC',
        btn1_1: 'KYC approuvé',
        text7_1: 'Le KYC du portefeuille actuel est en cours de révision, veuillez patienter',
        text7_2: 'Le KYC du portefeuille actuel a été approuvé!',
        text7_3: 'Le KYC du portefeuille actuel n\'a pas été approuvé, veuillez soumettre à nouveau!',
        text7_4: 'KYC du portefeuille actuel non soumis',
        btn2: 'Acheter DLC TOKEN',
        btn3: 'Lien de recommandation de 5%',
        btn3_1: 'Lien de recommandation de 10%',
        btn3_2: 'Lien de recommandation de 15%',
        btn3_3: 'Lien de recommandation de 20%',
      },
      success: 'Le lien a été copié dans le presse-papiers',
      error1: 'Veuillez connecter votre portefeuille d\'abord pour obtenir un code d\'invitation exclusif et gagner des récompenses',
      error2: 'Portefeuille non connecté, veuillez connecter votre portefeuille d\'abord',
      error3: 'La vérification KYC est en cours, veuillez attendre qu\'elle soit terminée avant d\'effectuer l\'achat',
      error4: 'La vérification KYC a échoué, veuillez soumettre à nouveau les informations de vérification KYC pour acheter',
      error5: 'Échec de l\'obtention des informations de vérification KYC, veuillez réessayer plus tard',
      error6: 'Veuillez attendre la fin du compte à rebours pour effectuer l\'achat.',
      error7: 'La Phase 3 est terminée, veuillez attendre le début de la Phase 4',
      tip1: 'DLC pas encore distribué',
      tip2: 'DLC a été distribué au portefeuille de l\'utilisateur',
      tip3: 'Paiement réussi',
    },
    rule: {
      title: 'Description des règles',
      text1: 'La vérification KYC est obligatoire et nécessite la soumission de documents d\'identification tels qu\'une carte d\'identité, un passeport ou un permis de conduire. Les résidents de Singapour, de Chine, des États-Unis, de Corée du Sud et de certains autres pays ne peuvent pas participer à l\'IDO.',
      // text2: 'Après la fin de la vente publique, le DLC sera coté sur les échanges DEX dans un délai de 7 jours et sur les échanges CEX dans un délai de 15 jours. L\'adresse du contrat intelligent du token DLC sur la chaîne BSC est : 0xD610Be30b06A3828A27D608a38F1E85faAFdEDcC',
      text2: "Huit échanges ont été confirmés pour inscrire DLC, et nous attendons qu'un échange majeur finalise le calendrier de l'inscription. Une fois le temps confirmé, toutes les bourses listeront DLC le même jour. Nous annoncerons la date à l'avance sur le compte officiel X. Adresse du contrat intelligent de la chaîne BSC du jeton DLC : 0xD610Be30b06A3828A27D608a38F1E85faAFdEDcC",
      text3: 'L\'achat de 20,000,000 DLC vous donne droit à une machine de minage de jeux DeepLink domestique avec GPU d\'une valeur de 1500 dollars. Cette offre est limitée au Japon et à l\'Europe, et les détails de l\'expédition seront notifiés par e-mail.',
      text3_btn: 'En savoir plus sur la machine de minage de jeux avec GPU domestique',
      text4: 'La vente publique sera fermée 48 heures après son lancement, et le prix de chaque DLC est de 0.003 USDT. 40% des tokens resteront déverrouillés et les 60% restants seront déverrouillés progressivement à partir du 31 août 2024. Veuillez noter que : 40% du DLC sera transféré à l\'adresse de votre portefeuille spécifiée quelques minutes après l\'achat, et les 60% restants seront transférés à votre portefeuille à l\'échéance du verrouillage.',
      text5: 'La Public Sale se déroulera en 5 étapes,',
      table: {
        table1_text1: 'phase',
        table1_text2: '2024/06/05-06/07',
        table1_text3: '2024/06/09-06/29',
        table1_text4: '2024/06/29-07/13',
        table1_text5: '2024/07/13-08/05',
        table1_text6: '2024/08/05-09/11',
        table2_text1: 'Quantité de DLC',
        table2_text2: '350,000,000DLC',
        table2_text3: '400,000,000DLC',
        table2_text4: '300,000,000DLC',
        table2_text5: '450,000,000DLC',
        table2_text6: '1,871,700,000DLC',
        table3_text1: 'Prix du DLC (USDT)',
        table3_text2: '0.003',
        table3_text3: '0.003',
        table3_text4: '0.003',
        table3_text5: '0.003',
        table3_text6: '0.003',
        table4_text1: 'Bonus',
        table4_text2: 'Bonus supplémentaire de 20% de DLC',
        table4_text3: 'Bonus supplémentaire de 15% de DLC',
        table4_text4: 'Bonus supplémentaire de 10% de DLC',
        table4_text5: 'Bonus supplémentaire de 5% de DLC',
        table4_text6: 'NO',
        table5_text1: 'Quantité',
        table5_text2: '1,050,000 USDT',
        table5_text3: '1,200,000 USDT',
        table5_text4: '900,000 USDT',
        table5_text5: '1,350,000 USDT',
        table5_text6: '5,615,100 USDT'
      }
    },
    ecology: {
      title: "Aperçu de l'écosystème du DeepLink Protocol",
      block1_title: 'Logiciel DeepLink',
      block1_text1: 'La fonction principale du logiciel DeepLink est le contrôle à distance et la plateforme de jeux en nuage',
      block1_text2: "DeepLink Protocol comprend DeepLink Protocol et DeepLink Software. Au cœur de DeepLink Software, on trouve des fonctions de contrôle à distance et de jeux en nuage, permettant aux utilisateurs de participer à des jeux à distance, au télétravail et d'accéder à des services de jeux basés sur le nuage. Actuellement, ce logiciel compte des utilisateurs dans 110 pays, avec plus de 400,000 téléchargements et plus de 200,000 portefeuilles créés dans le monde.",
      block1_btn1: 'En savoir plus sur le logiciel DeepLink',
      block2_title: 'Café internet en nuage et eSports en nuage',
      block2_text1: "Le café internet en nuage représente un modèle innovant de services de café internet et d'eSports, utilisant la technologie de rendu à ultra-faible latence du DeepLink Protocol.",
      block2_text2: "Dans cette configuration, les jeux et applications sont hébergés sur des serveurs GPU en nuage plutôt que sur des ordinateurs locaux, permettant aux utilisateurs d'accéder aux jeux et de jouer via des services en nuage sans avoir besoin d'une machine locale haute performance. Les cafés internet en nuage basés sur la technologie DeepLink sont en cours de déploiement dans plusieurs pays, notamment en Corée du Sud, en Chine, au Japon, au Vietnam, aux Philippines et en Inde, avec la participation de HYCONS, ZESTCLOUD, GLOWSTEAM et TIKEREN. Un cas opérationnel existe déjà en Corée du Sud.",
      block2_btn1: 'Voir la vidéo',
      block2_btn2: 'En savoir plus sur les cafés internet en nuage',
      block3_title: 'Console de jeux en nuage basée sur la blockchain',
      block3_text1: "Qu'est-ce qu'une console de jeux en nuage ?",
      block3_text2: 'La console de jeux en nuage basée sur la blockchain représente une avancée dans le matériel de jeux, offrant un taux de rafraîchissement FPS élevé pour une expérience de jeu eSports sans couture. Développée par le groupe HKC, la console de jeux en nuage TIKEREN utilise la technologie de rendu à ultra-faible latence de DeepLink, se connectant en temps réel aux serveurs GPU en nuage pour améliorer les performances de rendu des jeux.',
      block3_btn1: 'En savoir plus sur la console de jeux en nuage basée sur la blockchain',
      block4_title: 'Console portable de jeux en nuage basée sur la blockchain',
      block4_text1: "Qu'est-ce qu'une console portable de jeux en nuage ?",
      block4_text2: 'La console portable de jeux en nuage basée sur la technologie de rendu à ultra-faible latence de DeepLink offre une option plus rentable par rapport aux consoles portables traditionnelles, tout en offrant une expérience de jeu AAA fluide. En se connectant aux serveurs GPU en nuage pour le rendu des jeux en temps réel, elle réduit le coût de la console portable de 70 %.',
      block4_btn1: 'En savoir plus sur la console portable de jeux en nuage basée sur la blockchain',
    },
    coverage: {
      title: 'Carte de répartition des utilisateurs mondiaux du logiciel DeepLink',
      text: 'Nombre total d\'utilisateurs de DeepLink :'
    },
    track: {
      title: 'DeepLink Protocol est une combinaison de DePIN+IA+Jeux',
      text: "Appartient aux domaines les plus populaires de l'industrie blockchain actuelle",
      block1_title: 'Quelle est la taille du marché de DeepLink ?',
      block1_text: "Une des fonctions de DeepLink peut être comprise comme une version décentralisée de XBOX et PlayStation. À la fin de 2023, les ventes mondiales de la PS5 de Sony ont atteint 50 millions d'unités, et celles de la Xbox Series X|S ont atteint 30 millions d'unités. Les ventes totales de PS et Xbox ont dépassé les 200 millions d'unités, ce qui montre que le marché des jeux AAA haut de gamme est immense.",
      block2_title: "DeepLink, tout comme XBOX et PlayStation, s'adresse également aux joueurs de jeux AAA haut de gamme, mais son modèle économique est complètement différent",
      block2_text: "Les joueurs de DeepLink n'ont pas besoin d'acheter des consoles de jeux haut de gamme. Ils doivent simplement télécharger le logiciel DeepLink ou acheter une console de jeux en nuage basée sur la blockchain ou une console portable de jeux en nuage basée sur la blockchain. Les joueurs peuvent profiter d'une expérience de jeu AAA similaire à celle de XBOX et PlayStation, mais économisent 80 % des coûts matériels.",
      block3_title: 'Les mineurs fournissent des consoles de jeux AAA haut de gamme, qui sont des systèmes Windows compatibles avec tous les jeux AAA de Windows.',
      block3_text: "Les consoles de jeux des mineurs peuvent être à domicile ou dans des centres de données. Les consoles Xbox et PlayStation ne peuvent être utilisées que par leurs propriétaires et ne peuvent pas être louées à d'autres, ce qui entraîne une faible efficacité d'utilisation et un énorme gaspillage de ressources. La machine de minage de jeux de DeepLink peut être partagée avec n'importe qui, améliorant ainsi l'utilisation des ressources matérielles et offrant un nouveau modèle économique.",
      block4_title: 'Les mineurs qui fournissent des machines de minage de jeux peuvent obtenir des récompenses en tokens DLC',
      block4_text: "Cela incite davantage de mineurs à fournir des machines de minage de jeux. Les utilisateurs doivent payer avec des tokens DLC pour acheter du temps de jeu, élargissant ainsi les scénarios d'utilisation du DLC et augmentant le nombre de personnes possédant des tokens. La taille du marché potentiel des utilisateurs dépasse le milliard de personnes.",
      table: {
        table1_text1: 'Comparaison détaillée',
        table1_text2: 'Deep Link',
        table1_text3: 'Xbox',
        table1_text4: 'PS5',
        table2_text1: 'Jouer à des jeux AAA',
        table2_text2: "Les utilisateurs n'ont pas besoin d'acheter du matériel, ils doivent simplement télécharger le logiciel DeepLink",
        table2_text3: 'Les utilisateurs doivent acheter du matériel',
        table2_text4: 'Les utilisateurs doivent acheter du matériel',
        table3_text1: 'Console de jeux',
        table3_text2: 'Peut être louée pour gagner des $DLC, peut être louée plus de 12 heures par jour, retour sur investissement en 10 mois',
        table3_text3: 'Peut seulement être utilisée par le propriétaire, ne peut pas être louée, utilisée 2 à 4 heures par jour, ressources matérielles gaspillées',
        table3_text4: 'Peut seulement être utilisée par le propriétaire, ne peut pas être louée, utilisée 2 à 4 heures par jour, ressources matérielles gaspillées',
        table4_text1: 'Console portable',
        table4_text2: "Compatible, peut se connecter à n'importe quel matériel",
        table4_text3: 'Pas de console portable dédiée',
        table4_text4: "Compatible, ne peut se connecter qu'à la PS5",
        table5_text1: 'Console de jeux en nuage',
        table5_text2: 'Compatible',
        table5_text3: 'Non compatible',
        table5_text4: 'Non compatible',
        table6_text1: 'Café internet en nuage',
        table6_text2: 'Compatible',
        table6_text3: 'Non compatible',
        table6_text4: 'Non compatible',
      },
      btn1: 'DeepLink Software',
      btn2: 'DeepLink Protocol',
      btn3: "Présentation de l'équipe",
      btn4: 'Modèle économique'
    },
    faqs: {
      title: 'FAQS',
      text: 'Vous avez peut-être des questions, nous avons les réponses.',
      ques_title1: "1. Qu'est-ce que la Public Sale?",
      ques_text1: "Pendant la Public Sale, une quantité limitée de tokens sera vendue à un prix fixé aux personnes souhaitant participer tôt. C'est une excellente opportunité de devenir une partie de DeepLink avant le lancement réel du token. En participant à la Public Sale, vous pouvez acheter des tokens à un prix précoce avant leur offre publique. Par conséquent, la Public Sale peut être considérée comme une opportunité potentielle d'acheter des tokens avant qu'ils n'entrent en circulation et ne soient cotés en bourse.",
      ques_title2: '2. Pourquoi organisons-nous une Public Sale?',
      ques_text2_1: 'Nous organisons une Public Sale pour créer une communauté forte de détenteurs de $DLC, améliorer notre plateforme et lever des fonds pour attirer plus de joueurs dans notre écosystème.',
      ques_text2_2: "Les fonds levés pendant la Public Sale seront continuellement réinvestis dans les produits DeepLink, en introduisant de nouvelles fonctionnalités et en élargissant la base d'utilisateurs grâce à des activités de marketing. Cela nous permettra d'exécuter notre stratégie de promotion de marché avant le lancement du token $DLC.",
      ques_text2_3: "Notre objectif est d'atteindre 1,000,000,000 d'utilisateurs de DeepLink, ce qui fournira de nombreux scénarios d'utilisation pour le token $DLC et garantira le succès à long terme du token $DLC. Le token $DLC sera coté sur les échanges DEX et CEX, stimulant encore la croissance de l'écosystème DeepLink.",
      ques_text2_4: 'Rejoignez dès maintenant la Public Sale de DeepLink et devenez une partie de DeepLink!',
      ques_title3: '3. Quelle est la différence entre DeepLink Protocol et DeepLink Software?',
      ques_text3_1: 'DeepLink Protocol est un protocole de jeux en nuage AI décentralisé, combinant les technologies AI et blockchain pour fournir une technologie de rendu de jeux à ultra-faible latence.',
      ques_text3_2: 'DeepLink Software est un logiciel de contrôle à distance des jeux et une plateforme de jeux en nuage développée sur la base de DeepLink Protocol.',
      ques_text3_3: "D'autres produits développés sur la base de DeepLink Protocol incluent une plateforme de cybercafé en nuage, une console de jeux en nuage basée sur la blockchain et une console portable de jeux en nuage basée sur la blockchain, entre autres.",
      ques_title4: "4. En quoi consiste l'innovation de DeepLink Protocol?",
      ques_text4: "DeepLink résout les principales difficultés rencontrées par l'industrie des jeux en nuage en utilisant la technologie blockchain et AI, et attire les mineurs et les machines GPU inactives grâce à un mécanisme d'incitation par les tokens. Il attire également la bande passante inactive pour résoudre les deux problèmes clés de l'industrie des jeux en nuage. La technologie AI améliore la qualité graphique des jeux, améliorant ainsi l'expérience utilisateur.",
      ques_title5: "5. Qu'est-ce que le $DLC Token?",
      ques_text5: "Le $DLC Token est le seul moyen de paiement dans l'écosystème DeepLink. Les utilisateurs doivent payer avec $DLC Token pour acheter du temps de jeu en nuage, louer des ordinateurs de jeux en nuage, acheter des licences, etc.",
      ques_title6: '6. Qui sont les clients cibles de DeepLink Protocol?',
      ques_text6_1: "1) Entreprises de jeux AAA : Aide à convertir les jeux AAA en jeux en nuage, permettant aux jeux AAA de fonctionner sur n'importe quel appareil bas de gamme, y compris les téléphones mobiles, augmentant ainsi la base d'utilisateurs de jeux AAA de plus de 10 fois.",
      ques_text6_2: "2) Cybercafés et hôtels eSports : Aide à moderniser les cybercafés traditionnels en les transformant en cybercafés en nuage, réduisant l'investissement matériel de plus de 80 % et augmentant les bénéfices nets de 3 fois en 4 ans.",
      ques_text6_3: "3) Fabricants de matériel de consoles de jeux en nuage : Les fabricants peuvent intégrer DeepLink Protocol, permettant de jouer à des jeux AAA avec une configuration CPU bas de gamme et un écran de jeu haut de gamme, économisant ainsi 80 % de l'investissement matériel des joueurs.",
      ques_text6_4: "4) Fabricants de consoles portables de jeux en nuage : Les fabricants peuvent intégrer DeepLink Protocol, ce qui fait que le prix de la console portable est de 30 % du prix d'une console traditionnelle, avec des performances de jeu plus de 5 fois supérieures à celles d'une console portable traditionnelle.",
      ques_title7: '7. Qui sont les clients cibles de DeepLink Software?',
      ques_text7: 'Ce sont 3 milliards de joueurs potentiels dans le monde entier, permettant aux joueurs de profiter de jeux AAA haut de gamme sur leurs téléphones mobiles, ordinateurs bas de gamme, Mac et télévisions.',
      ques_title8: "8. Y a-t-il une période d'acquisition?",
      ques_text8: "40 % des DLC Tokens achetés ne sont pas bloqués, 60 % seront débloqués sur une période de 150 jours à partir d'environ le 31 août 2024, avec un déblocage de 10 % tous les 30 jours.",
      ques_title9: '9. Comment acheter $DLC?',
      ques_text9: "Participez d'abord à la KYC, soumettez vos informations personnelles et, une fois approuvé, vous pourrez participer à l'achat de $DLC lorsque la Public Sale commencera.",
    },
    buy: {
      title: 'Comment acheter?',
      step1: 'Étape 1:',
      step1_text: 'Connectez votre portefeuille Metamask ou Trust Wallet',
      step2: 'Étape 2:',
      step2_text: 'Confirmez la transaction. Vous pouvez utiliser USDT pour acheter $DLC',
      step3: 'Étape 3:',
      step3_text: 'Vous pouvez réclamer votre $DLC après la fin de la vente publique',
      btn1: 'Besoin d\'aide',
      btn2: 'Acheter DLC',
    },
    potential: {
      title: 'Growth Potential', 
      text1_1: "La capitalisation boursière de plusieurs tokens dans le secteur DePIN n'a cessé de croître après leur cotation en bourse.",
      text1_2: '$ 888',
      text1_3: '$ 2288',
      text1_4: '$ 5888',
      text1_5: '$ 12888',
      text2: "DeepLink Software a un marché potentiel de plus d'un milliard d'utilisateurs, ce qui amènera un grand nombre d'utilisateurs web2 dans le monde web3. Le nombre potentiel de détenteurs de $DLC dépasse le milliard de personnes.",
      text3: "Il y a plus de 200 000 cybercafés eSports dans le monde. À l'avenir, plus de 50 % des cybercafés traditionnels seront transformés en cybercafés en nuage. La technologie des cybercafés en nuage a un large potentiel d'application et chaque cybercafé en nuage devra utiliser $DLC pour les paiements, ce qui entraînera une utilisation massive de $DLC.",
      text4: "En se basant sur les chiffres de vente de XBOX et PS5, le nombre d'utilisateurs achetant des consoles de jeux en nuage basées sur la blockchain et des consoles portables de jeux en nuage dépassera les 100 millions, ce qui apportera une énorme valeur à $DLC."
    },
    report: {
      title: 'DeepLink dans les Médias'
    },
    prompt: {
      title: "Avis d'Information",
      text1: 'DeepCloudX.PTE.LTD exploite le site web deeplink.cloud ("la plateforme").',
      text2: "En utilisant cette plateforme, vous acceptez nos conditions de service, notre politique de confidentialité, notre politique de cookies et notre accord de vente de tokens DLC. Dans votre juridiction, les cryptomonnaies peuvent ne pas être réglementées. La valeur des cryptomonnaies peut augmenter ou diminuer. Les bénéfices peuvent être affectés par l'impôt sur les gains en capital ou d'autres impôts applicables dans votre juridiction. Rien sur ce site web ne doit être interprété comme une offre ou une recommandation d'achat, de vente ou d'investissement. Vous êtes entièrement responsable de déterminer si un achat ou une transaction liée est approprié pour vous, en fonction de vos objectifs personnels, de votre situation financière et de votre tolérance au risque.",
      text3: "Vous devez consulter des professionnels légaux et des conseillers fiables et agréés pour obtenir des conseils juridiques, fiscaux, d'assurance ou commerciaux. DLC ne garantit aucune performance, résultat ou retour de capital pour aucune cryptomonnaie sur ce site web. En accédant à ce site web et à l'une de ses pages, vous acceptez d'être lié par l'accord de vente de DLC. L'achat de cryptomonnaies comporte des risques et peut entraîner une perte partielle ou totale."
    }
  },
  dialog1: {
    title: 'Soumettre les informations KYC',
    text1: 'Télécharger les informations d\'identité:',
    text2: 'Télécharger une photo tenant le document d\'identité:',
    text3: 'Informations frontales de la carte d\'identité, du passeport ou du permis de conduire',
    text4: 'Le visage et les informations d\'identité doivent être clairement visibles',
    text5: 'Quantité de DLC que vous souhaitez acheter:',
    text6: 'Adresse du portefeuille certifié:',
    text7: 'Vous recevrez une récompense de 1000 DLC après avoir réussi la vérification KYC, et les DLC bloqués pendant la Public Sale seront également envoyés à cette adresse de portefeuille',
    text7_1: 'Seule cette adresse peut être utilisée pour acheter des DLC après la vérification KYC, l\'adresse d\'un échange ne peut pas être utilisée',
    text8: 'Où créer une adresse de portefeuille DLC sur la chaîne DBC?',
    text9: 'Ou',
    text10: 'Entrez votre adresse e-mail:',
    text11: 'Obtenir le code de vérification',
    text12: 'Entrez le code de vérification:',
    text13: 'Renvoyer dans {secs} secondes',
    text14: '(Maximum 20,000,000 DLC, vous ne pouvez acheter que la quantité approuvée par la vérification KYC lorsque la Public Sale commence)',

    success1: 'Code de vérification envoyé !',
    success2: 'Informations soumises avec succès, en attente de révision',
    error1: 'Vous devez sélectionner un fichier image !',
    error2: 'Le fichier image ne peut pas être vide !',
    error3: 'Le nom d\'utilisateur ne peut pas être vide !',
    error4: 'L\'adresse du portefeuille ne peut pas être vide !',
    error5: 'L\'email ne peut pas être vide !',
    error6: 'Veuillez entrer une adresse email valide !',
    error7: 'Le code de vérification ne peut pas être vide !',
    error8: 'Échec de l\'envoi du code de vérification, veuillez réessayer plus tard !',
    error9: 'Échec de l\'ajout',
    error10: 'Code de vérification incorrect, veuillez réessayer',
    error11: 'Échec de la consultation des informations par email',
    error12: 'La quantité d\'achat ne peut pas dépasser 20 000 000',
    error13: 'Le code de vérification a expiré, veuillez en obtenir un nouveau',
    error14: 'Informations soumises avec succès, échec de l\'envoi de l\'email de confirmation',
    error15: 'Si vous n\'avez pas reçu l\'email, veuillez vérifier dans votre dossier de spam',
    error16: 'L\'image ne doit pas dépasser 5 Mo',
    error17: 'Veuillez ne pas soumettre de données de vérification KYC plusieurs fois',
    tip1: '(Conseil amical : les informations personnelles ne sont utilisées que pour la vérification KYC, et non à d\'autres fins)',
  },
  dialog2: {
    title: 'Acheter des DLC',
    text1: 'Quantité de DLC à acheter:',
    text2: 'Vous devez acheter au moins 150 000 DLC',
    text3: 'Sélectionnez la crypto-monnaie de paiement:',
    text4: 'Entrez l\'adresse du portefeuille DLC sur la chaîne DBC:',
    text5: '40 % des DLC seront transférés à cette adresse de portefeuille en quelques minutes, et les 60 % restants seront transférés à cette adresse de portefeuille lorsque le verrouillage expirera',
    text6: 'Où créer une adresse de portefeuille DLC sur la chaîne DBC?',
    text7: 'Ou',
    text8: 'Équivalent en USDT:',
    text9: 'Sélectionnez le mode de paiement:',
    text9_1: 'Payer avec le portefeuille actuellement connecté',
    text9_2: 'Payer avec le code QR',
    error1: 'La quantité de DLC ne peut pas être vide',
    error2: 'Veuillez entrer un numéro',
    error3: 'Le nombre entré doit être supérieur à 50 000',
    error4: 'L\'adresse du portefeuille ne peut pas être vide',
    error5: 'Échec de la création de la commande',
    success1: 'Paiement réussi, les DLC seront transférés à votre adresse de portefeuille en quelques minutes, veuillez vérifier!',
    success2: 'Paiement réussi via le lien de redirection, les DLC seront transférés à votre adresse de portefeuille en quelques minutes, veuillez vérifier!',
    error6: 'La quantité d\'USDT ne peut pas être vide',
    error7: 'La quantité d\'USDT ne peut pas être inférieure à 150',
    error8: 'La quantité d\'USDT ne peut pas être supérieure à 60 000',
    error9: 'Le montant du paiement ne correspond pas au montant prévu, veuillez contacter l\'administrateur pour confirmer si c\'est correct',
  },
  dialog3: {
    title: 'Présentation de l\'appareil tout-en-un',
    text1: '1. Qu\'est-ce qu\'un appareil de jeux en nuage tout-en-un?',
    text2: 'L\'appareil de jeux en nuage tout-en-un, comparé aux appareils tout-en-un traditionnels, offre un écran avec un taux de rafraîchissement élevé en FPS, offrant une expérience de jeu fluide. L\'appareil de jeux en nuage TIKEREN du groupe HKC est développé avec la technologie DeepBrainChain + DeepLink et peut se connecter en temps réel à des GPU haute performance distants pour le rendu et le calcul des jeux. L\'appareil est équipé d\'un système Windows intégré et peut être utilisé pour le travail et le divertissement normaux, permettant la diffusion de jeux depuis votre propre GPU haute performance via DeepLink. Lorsque vous ne disposez pas d\'un GPU haute performance, vous pouvez vous connecter à un GPU haute performance distant via DeepLink pour jouer à des jeux AAA, en payant un certain montant de DLC Token par heure.',
    text3: '2. Présentation de l\'appareil TIKEREN',
    table: {
      th: {
        text1: 'Projet',
        text2: '27 pouces',
        text3: '31.5 pouces',
      },
      td1: {
        text1: 'Mode Type',
        text2: 'MA27H13QC1',
        text3: 'MA27H13QC1'
      },
      td2: {
        text1: 'Color Category',
        text2: 'Black',
        text3: 'Black'
      },
      td3: {
        text1: 'Display Size',
        text2: '27 pouces',
        text3: '31.5 pouces',
      },
      td4: {
        text1: 'Aspect Ratio',
        text2: 'Wide (16:9)',
        text3: 'Wide (16:9)'
      },
      td5: {
        text1: 'Panel Type',
        text2: 'IPS',
        text3: 'VA'
      },
      td6: {
        text1: 'Panel Resolution',
        text2: 'QHD 2560*1440',
        text3: 'QHD 2560*1440'
      },
      td7: {
        text1: 'Panel Refresh Rate',
        text2: '180Hz (Max)',
        text3: '170Hz(Max)'
      },
      td8: {
        text1: 'Responese Time',
        text2: '1mS(MPRT) GTG 1ms',
        text3: '1ms(MPRT) GTG 1ms'
      },
      td9: {
        text1: 'Color Gamut',
        text2: 'DCIP3 90%',
        text3: 'DCIP3 90%'
      },
      td10: {
        text1: 'Mainboard Solution',
        text2: 'Intel® N100 Chipset',
        text3: 'Intel® N100 Chipset'
      },
      td11: {
        text1: 'CPU/Cooler',
        text2: 'Intel N100 3.4GHz',
        text3: 'Intel N100 3.4GHz'
      },
      td12: {
        text1: 'Memory',
        text2: 'DDR4 8GB(Option Max 32G)',
        text3: 'DDR4 8GB(Option Max 32G)'
      },
      td13: {
        text1: 'Hard Disk',
        text2: 'SSD 128G(Option Max 1T)',
        text3: 'SSD 128G(Option Max 1T)'
      },
      td14: {
        text1: 'OS',
        text2: 'Windows 10/11(0ption)',
        text3: 'Windows 10/11(0ption)'
      },
      td15: {
        text1: 'GPU',
        text2: 'Intel UHD Graphics',
        text3: 'Intel UHD Graphics'
      },
      td16: {
        text1: 'Rear Interface',
        text2: '1*DC Power Connector，1*RJ45(2.5G)，4* USB 3.0，1*Audio jacks',
        text3: '1*DC Power Connector，1*HDMIN，1*HDMI OUT，1*RJ45(2.5G)，4* USB 3.0,1*Audio iacks'
      },
      td17: {
        text1: 'Side Interface',
        text2: 'USB 2.0x2，Power Button x1',
        text3: 'USB 2.0x2，Power Button x1'
      },
      td18: {
        text1: 'Wi-Fi',
        text2: '2.4G~5GHz(Wi-Fi5)，BT(4.2)',
        text3: '2.4G~5GHz(Wi-Fi5)，BT(4.2)'
      },
      td19: {
        text1: 'Audio',
        text2: 'Built-in Speakers*2',
        text3: 'Built-in Speakers*2'
      },
      td20: {
        text1: 'Base/Stand',
        text2: 'HAS:VESA',
        text3: 'HAS:VESA'
      },
      td21: {
        text1: 'Pivot',
        text2: 'Haut, bas, gauche, droite, rotation à 90°, réglage en hauteur',
        text3: 'Haut, bas, gauche, droite, rotation à 90°, réglage en hauteur', 
      },
      td22: {
        text1: 'Power',
        text2: '90W',
        text3: '90W'
      },
      td23: {
        text1: 'Game Screen lmprovement',
        text2: 'Free Sync, G-Sync',
        text3: 'Free Sync, G-Sync'
      }
    },
    btn: 'Compris'
  },
  dialog4: {
    title: 'Présentation de la console de jeux en nuage portable',
    text1: '1. Qu\'est-ce qu\'une console de jeux en nuage portable?',
    text2: 'La console de jeux en nuage portable se distingue des consoles portables traditionnelles par le fait qu\'elle est développée avec la technologie de rendu à ultra faible latence de DeepLink, permettant une connexion en temps réel aux serveurs GPU en nuage pour des performances de jeu supérieures. Cela réduit les coûts de la console portable de 70 % et permet une expérience de jeu fluide pour les jeux AAA. La console portable intègre Google Play pour télécharger des jeux Android et permet également la diffusion de jeux depuis votre propre GPU haute performance sous Windows/PS/XBOX. Si vous ne disposez pas d\'un GPU haute performance, vous pouvez vous connecter à un GPU haute performance distant via DeepLink pour jouer à des jeux AAA, en payant une certaine quantité de DLC Token par heure.',
    text3: '2. Présentation de la console de jeux en nuage basée sur la blockchain',
    btn: 'Compris'
  },
  dialog5: {
    title: 'Présentation du Mineur de Jeux à Domicile avec GPU',
    text1: '1. Qu\'est-ce qu\'un mineur de jeux à domicile avec GPU?',
    text2: 'Le mineur de jeux avec GPU est équipé d\'un GPU NVIDIA 4070 Super, d\'un CPU Intel i7-13700F, de 32 Go de RAM et de 2 To d\'espace disque SSD. Il intègre le logiciel de minage et le système de gestion DeepLink. N\'importe qui peut installer cette machine chez lui pour gagner des récompenses en DLC. Chaque année, 1 milliard de tokens DLC sont distribués en récompenses à toutes les machines de minage de jeux, qu\'elles soient louées par des utilisateurs pour jouer ou non. En configurant le mineur de jeux avec GPU pour la location, il est possible d\'obtenir des récompenses en DLC ainsi que des revenus de location en DBC. De plus, lorsqu\'il n\'y a pas d\'utilisateurs louant la machine, d\'autres tokens peuvent être minés, générant des revenus 24 heures sur 24.',
    text3: '2. Présentation du mineur de jeux à domicile avec GPU',
    text4: '3. Caractéristiques techniques',
    text5_1: 'With RTX4070 Super Graphics Card',
    text5_2: 'Core i7-13700F, 16 Cores, 24 Threads, Base 1.5/2.1 GHz, Max 4.1/5.1GHz;',
    text5_3: 'Graphics Card GeForce RTX4070 Supe12G. Support 3rd Gen Ray Tracing and 4th Tensor Core.',
    text5_4: 'RAM Dual DDR4, Max 64GB (32GB*2).',
    text5_5: 'Hard Drive Ports One M2 2280 NVME SSD, and support to add double 2.5" SATA hard drive.',
    text5_6: 'Ports 4*USB 3.2, 4* USB 2.0, 3*DisplayPort, 1*HDMI, 2*LAN, 1*Optical, 1*Audio, 1*DC-IN, 2*WiFi ports.',
    text5_7: 'Operating System Preinstall with Windows 11 Pro.',
    btn: 'Compris'
  }
}